export class DocumentModel {
  itemLevel: number = 0;
  recordId: string = "";
  formId: string = "";
  pKTableId: number =0;
  documentName: string = "";
  file: File=null;
  folderPath: string = "";
  fileName: string = "";
  fileType: string = "";
  isActive: boolean = true;
  isDefault: boolean = true;
  description: string = "";
  documentType: string = "0";
  documentCategory: string = "0";
  clientId: number = 0;
  clientCode: string = "";
  isDelete: boolean = false;
  isDeactivate: boolean = false;
  createdOnUTC: Date = new Date();
  createdBy: string = "";
  updatedOnUTC: Date = new Date();
  updatedBy: string = "";
  userId: string = "";
}
export class DocumentConfigurationModel {
  itemLevel: number = 0;
  formId: string = "";
  recordId: string = "";
  pkTableId: string = "";
  storageName: string = "DocumentsData";
  formTitle: string = "Document Upload";
  addFormName: string = "Document Upload";
  editFormName: string = "Document Upload";
  listReportFormName: string = "Saved Document List";
  documentToUpload:string ="Document"
  addEditInModalPopUp: boolean = true;
  allowAdd: boolean = true;
  allowEdit: boolean = true;
  allowDelete: boolean = true;
  allowphotosOnly: boolean = true;
  allowImageAnnotation: boolean = false;
  showFileList: boolean = false;
  showFileListUploadBtns: boolean = false;
  showMainForm: boolean = true;
  fileNameDiv: boolean = true;
  selectSubmit: boolean = false;
  fileTempTable: boolean = true;
  fileuploadDiv:boolean=true;
  fileclearDiv:boolean=true;
  allowAddMultipleDocuments: boolean = false;
  saveDocumentFromParent: boolean = false;
  displayListCardView: boolean = true;
  autoSave: boolean = false;
  requiredFields: RequiredAddressFields = { documentName: true, file: true, documentType: false, documentCategory: false, description: true };
  allowedFields: AllowedAddressFields = { documentName: true, file: true, documentType: false, documentCategory: false, description: false };
}



export class AllowedAddressFields {
  documentName: boolean=true;
  file: boolean= true;
  documentType: boolean=false;
  documentCategory: boolean= false;
  description: boolean= true;
}

export class RequiredAddressFields {
  documentName: boolean = true;
  file: boolean = true;
  documentType: boolean= false;
  documentCategory: boolean= false;
  description: boolean=true;
}

export class RequiredFieldValidationModel {
  isDocumentNameValid: boolean = true;
  documentNameValidationMessage: string = "Document Name is required";

  isFileValid: boolean = true;
  fileValidationMessage: string = "File is required";
}
